import { AssetFormat, ContributionItem, TransferStatuses } from 'services/requests';
import { convertDate, formatUSD } from 'utils';
import { CustomColumn } from 'components/Table/Table.types';
import AssignDepositButton from 'components/AssignDepositButton';

import styles from './ContributionsTable.module.css';

export type MapData = ContributionTableSign[];

export type ContributionTableSign = Omit<ContributionItem, 'asset'> & {
  asset: string;
  icon: JSX.Element | undefined;
};

export const mapData = (data: ContributionItem[] | undefined): MapData | undefined =>
  data?.map((contributionItem: ContributionItem) => ({
    ...contributionItem,
    created: convertDate(contributionItem.created),
    updated: convertDate(contributionItem.updated),
    asset:
      contributionItem.asset.assetFormat === AssetFormat.FIAT
        ? formatUSD(contributionItem.asset.amount)
        : `${contributionItem.asset.amountStringified} ${contributionItem.asset.code}`,
    icon:
      contributionItem.status === TransferStatuses.NonProcessed ? (
        <AssignDepositButton contributionItemInfo={contributionItem} />
      ) : undefined,
  }));

export const columns: CustomColumn<ContributionTableSign>[] = [
  {
    Header: 'Transfer ID',
    accessor: 'externalId',
    className: styles.idColumn,
  },
  {
    Header: 'Amount',
    accessor: 'asset',
    className: styles.amountColumn,
  },
  {
    Header: 'Type',
    accessor: 'externalType',
    className: styles.typeColumn,
  },
  {
    Header: 'Created',
    accessor: 'created',
    className: styles.createdColumn,
  },
  {
    Header: 'Updated',
    accessor: 'updated',
    className: styles.updatedColumn,
  },
  {
    Header: 'Status',
    accessor: 'status',
    className: styles.statusColumn,
  },
  {
    Header: '',
    accessor: 'icon',
    className: styles.iconColumn,
  },
];
